<template>
    <v-server-table
        :url="`${url}`"
        :columns="columns"
        :options="options"
        @row-click="onRowClick"
    >
        <div slot="afterLimit" class="flex flex-row justify-end">
            <button
                type="button"
                @click="toggleFilters"
                class="focus:outline-none text-gray-800 hover:text-gray-600"
            >
                <div class="flex items-center">
                    <span>{{ showFilters ? "Hide" : "Show" }} filters</span>
                    <svg
                        class="w-6 h-6 ml-2 outline-none"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M8 16l2.879-2.879m0 0a3 3 0 104.243-4.242 3 3 0 00-4.243 4.242zM21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        ></path>
                    </svg>
                </div>
            </button>
        </div>
    </v-server-table>
</template>
<script>
export default {
    name: "BaseTable",
    props: {
        url: {
            type: String,
            required: true,
        },
        columns: {
            type: Array,
            required: true,
        },
        headings: {
            type: Object,
            required: false,
        },
        query: {
            type: Object,
            required: false,
        },
        sortable: {
            type: Array,
            default: () => [],
            required: false,
        },
        editRoute: {
            type: String,
            default: 'edit_route',
            required: false,
        },
        clickOpensNewTab: {
            type: Boolean,
            default: false,
            required: false,
        },
    },
    data() {
        return {
            showFilters: false,
            options: {
                perPage: 25,
                filterByColumn: true,
                pagination: {
                    chunk: 5,
                },
                headings: this.headings,
                sortable: this.sortable,
                requestKeys: {
                    query: "tableQuery",
                },
                sortIcon: {
                    base:'fas fa-sort',
                    up:'fas fa-sort-down',
                    down:'fas fa-sort-up',
                    is:'fas fa-sort',
                }
            },
        };
    },
    methods: {
        onRowClick: function (event) {
            let redirectRoute = event.row;
            if(this.editRoute.includes('.')){
                const nesting = this.editRoute.split('.');
                nesting.forEach(nest => redirectRoute = redirectRoute[nest]);
            }else{
                redirectRoute = redirectRoute[this.editRoute]
            }
            this.redirectRaw(redirectRoute || event.row.show_route, this.clickOpensNewTab);
        },
        toggleFilters: function () {
            this.showFilters = !this.showFilters;
            if (this.showFilters) {
                document.querySelector(
                    "thead tr.VueTables__filters-row"
                ).style.display = "table-row";
            } else {
                document.querySelector(
                    "thead tr.VueTables__filters-row"
                ).style.display = "none";
            }
        },
    },
};
</script>
